export default {
  controlpacks: {
    title: "Контроль разноски пачек",
    storn: {
      modal: {
        title: "Причина возврата пачки"
      },
      card: {
        selectTypeStornPack: "Выберите тип сторнировки пачки",
        chooseReason: "Выберите причину"
      },
      form: {
        typeStornId: {
          onlyBreakLink: "Только разорвать связь между пачкой и платежем",
          stornPack: "Сторнировать пачку и все ее квитанции"
        }
      }
    },
    edit: {
      modal: {
        infoPack: "Информация о пачке",
        compensationDisability: "Компенсация инвалидам по зрению",
        socialSupplementInfo: "Информация о социальной доплате",
        subsidyInfo: "Информация о субсидии"
      },
      form: {
        packnumber: {
          title: "Банковский номер пачки"
        },
        datebank: {
          title: "Дата по банку"
        },
        codefirme: {
          title: "Плательщик"
        },
        accountSender: {
          title: "Р/счет плательщика"
        },
        kindpay: {
          title: "Способ оплаты"
        },
        quantity: {
          numberSubs: "Кол-во абонентов",
          numberReceipts: "Кол-во квитанций"
        },
        countband: {
          numberSheets: "Кол-во листов",
          numberCountband: "Кол-во бандеролей"
        },
        summa: {
          title: "Сумма"
        },
        sumprof: {
          title: "За услуги"
        },
        userid: {
          title: "Оператор"
        }
      }
    },
    receipts: {
      modal: {
        title: "Информация о пачке"
      },
      form: {
        summa: {
          title: "Cумма"
        },
        datebank: {
          title: "Дата по банку"
        },
        quantity: {
          title: "Квитанций"
        },
        countband: {
          title: "Бандеролей"
        },
        reasonname: {
          title: "Причина возврата"
        }
      }
    },
    controlPacksColumn: {
      headers: {
        packs: "Пачка",
        payment: "Платеж"
      }
    },
    packsCountbandColumn: {
      headers: {
        packsCountband: "Бандероли"
      }
    },
    packsQuantityColumn: {
      headers: {
        packsQuantity: "Квитанции"
      }
    },
    filterStatusOptions: {
      undeployed: "Неразнесенная",
      deployed: "Разнесенная",
      invalid: "Ошибочная"
    },
    statusPrepareChangeCheck: {
      title: "Сторнирование"
    },
    statusAfterQuestion: {
      title: "Сторнирование"
    },
    statusModifyPacksReceipts: {
      title: "Изменение"
    },
    statusInfoPack: {
      title: "Успешно",
      pack: "Пачка",
      wasDeliver: "была разнесена"
    },
    stornModalSubmit: {
      returnReason: "Причина возврата",
      allReceiptsDeleted:
        "Все внесенные квитанции выбранной пачки будут удалены",
      continue: "Продолжить",
      confirm: {
        title: "Сторнирование"
      }
    }
  }
};
